angular.module('eStories.autocomplete', [
    /*Search Bar*/
    'eStories.paging.model',
    'eStories.search.model'
])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.searchBar', {
                url: '^eStories.navbars',
                views: {
                    'searchBar@': {
                        templateUrl: 'search/autocomplete.tmpl.html',
                        controller: 'AutocompleteCtrl as autocompleteCtrl'
                    }
                }
            });
    }])

    .controller('AutocompleteCtrl', ['$rootScope', '$scope', 'SearchModel', 'PagingModel', "$location", "LL",
        function ($rootScope, $scope, SearchModel, PagingModel, $location, LL) {
            var autocompleteCtrl = this;

            /*Listener to event on navbarsCtrl, shows searchBar*/
            $rootScope.$on('showSearchbar', function (event) {
                //disableScroll();
                autocompleteCtrl.searchOn = true;
                autocompleteCtrl.autocompleteResults = null;
            });

            /*Hides searchBar, broadcasts event to toggle navbar states*/
            autocompleteCtrl.hideSearchbar = function () {
                //enableScroll();
                $rootScope.$broadcast('hideSearchbar');
            };

            $scope.$on('hideSearchbar', function () {
                autocompleteCtrl.searchOn = false;
            });

            autocompleteCtrl.seeSearchResults = function (textToFind) {
                $location.path("/search/store/" + textToFind);

                if (autocompleteCtrl.autocompleteResults) {
                    LL.tagSearchCatalogEvent(
                        textToFind,
                        autocompleteCtrl.autocompleteResults.authorCount,
                        autocompleteCtrl.autocompleteResults.narratorCount,
                        autocompleteCtrl.autocompleteResults.publisherCount,
                        autocompleteCtrl.autocompleteResults.audiobookCount,
                        true,
                        SearchModel.createArrayOfBookIds(autocompleteCtrl.autocompleteResults)
                    );
                    autocompleteCtrl.hideSearchbar();
                }
            };

            autocompleteCtrl.previousSearch = null;
            autocompleteCtrl.autocompleteResults = null;
            autocompleteCtrl.shouldHideResults = function () {
                if (!autocompleteCtrl.autocompleteResults) {
                    return true;
                }

                return !(autocompleteCtrl.autocompleteResults.audiobookCount ||
                    autocompleteCtrl.autocompleteResults.authorCount ||
                    autocompleteCtrl.autocompleteResults.publisherCount ||
                    autocompleteCtrl.autocompleteResults.narratorCount);
            };

            autocompleteCtrl.autocompleteStore = function (textToFind) {
                if (autocompleteCtrl.previousSearch != null) {
                    clearTimeout(autocompleteCtrl.previousSearch);
                    autocompleteCtrl.previousSearch = null;
                }

                if (textToFind == null || textToFind === "") {
                    autocompleteCtrl.autocompleteResults = null;
                    return;
                }

                autocompleteCtrl.previousSearch = setTimeout(async () => {
                    const numberOfTextResults = 3;
                    const numberOfGridResults = 10;
                    const desc = true;
                    const narratorPagination = PagingModel.preparePagination(1, numberOfTextResults, desc, false);
                    const authorPagination = PagingModel.preparePagination(1, numberOfTextResults, desc, false);
                    const publisherPagination = PagingModel.preparePagination(1, numberOfTextResults, desc, false);
                    const audiobookPagination = PagingModel.preparePagination(1, numberOfGridResults, desc, false);

                    autocompleteCtrl.autocompleteResults = await SearchModel.autocompleteStore(textToFind,
                        narratorPagination,
                        publisherPagination,
                        authorPagination,
                        audiobookPagination);
                    safeApply($scope)

                }, 50);
            };

            /*Localytics Search Select Events for Autocomplete*/
            autocompleteCtrl.tagSearchSelectAuthorLlEvent = function (author) {
                LL.tagSearchSelectAuthorLlEvent(author.name, true);
            };

            autocompleteCtrl.tagSearchSelectNarratorLlEvent = function (narrator) {
                LL.tagSearchSelectNarratorLlEvent(narrator.name, true);
            };

            autocompleteCtrl.tagSearchSelectPublisherLlEvent = function (publisher) {
                LL.tagSearchSelectPublisherLlEvent(publisher.name, true);
            };

            autocompleteCtrl.tagSearchSelectTitleLlEvent = function (bookObj) {
                LL.tagSearchSelectTitleLlEvent(bookObj.title, true);
            };
        }]);
